import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { set } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';

const forgotPassword = createAsyncThunk('auth/forgotPassword',
  async (formData = {}, { rejectWithValue }) => {
    try {
      return await set(METHOD_POST, '/forgot_password', formData);
    } catch (error) {
      return rejectWithValue(error?.message || 'error on send email');
    }
  });

export const clearForgotPassword = createAction('auth/clearForgotPassword');

export default forgotPassword;
